import { ListProps, Paging } from '@Core';
import { BaseHttpController } from '@Core/controller/BaseHttpController';
import { PTZPresets } from '@EcamModel/model/PTZPresets';
import { AxiosInstance } from 'axios';
import { IPTZPresetHttpController } from '../IPTZPresetHttpController';

export class PTZPresetHttpController extends BaseHttpController<PTZPresets> implements IPTZPresetHttpController {
    constructor(serviceUrl: string, client: AxiosInstance) {
        super(serviceUrl, 'ptz-preset', client);
    }

    async syncPtzPresets(cameraId: number): Promise<boolean> {
        return await this.doPost({ path: `sync/${cameraId}` }).then((res) => res.data);
    }

    async list(props: ListProps<PTZPresets>): Promise<Paging<PTZPresets>> {
        return await this.doPost({ path: 'list', body: props }).then((res) => res.data);
    }
}
